/*
 *
 * Created on Thu 12 May 2023
 *
 * Copyright (c) 2023 One97 communications
 * @author poonam.chandra
 * @modified By :
 *
 */

const BannerType = {
  SIMPLE_BANNER: "simple_banne",
  SINGLE_IMAGE_BANNER: "single_Image_banner",
  CHANNEL_BANNER: "channel_banner",
  SERVICE_BANNER: "service_banner",
  CASE_STUDY: "case_study",
  COMMENT_BANNER: "comment_banner",
  PLATFORMS_BANNER: "platforms_banner",
  VIDEO_BANNER: "video_banner",
};

export default BannerType;
